

















































































































































































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { timeout } from '@/utils/common'
import moment from 'moment'

@Component
export default class ViewFinanceiroRelatorioPerfil extends Vue {
  $refs!: { formItemVinculoRelatorio: any }

  prestadorSearchGlobal: string = ''
  prestadorSearchModal: string = ''
  loadPrestadores: boolean = false
  loadPrestadoresGlobal: boolean = false
  lastPrestadorSearch: string = ''
  suppressPrestadorSearchModal: boolean = false

  get loadingPrestadores() { return this.loadPrestadores }
  set loadingPrestadores(value: boolean) { this.loadPrestadores = value }
  get loadingPrestadoresGlobal() { return this.loadPrestadoresGlobal }
  set loadingPrestadoresGlobal(value: boolean) { this.loadPrestadoresGlobal = value }

  debouncedBuscarPrestadores = _.debounce((filtro: string) => {
    this.buscarPrestadores(filtro)
  }, 500)

  loadEditarItemPontuacaoProfissional: string = ''
  get loadingEditarItemPontuacaoProfissional() { return this.loadEditarItemPontuacaoProfissional }
  set loadingEditarItemPontuacaoProfissional(value: string) { this.loadEditarItemPontuacaoProfissional = value }

  loadDataTable: boolean = false
  get loadingDataTable() { return this.loadDataTable }
  set loadingDataTable(value: boolean) { this.loadDataTable = value }

  loadDeleteItemPontuacaoProfissional: boolean = false
  get loadingDeleteVinculoRelatorios() { return this.loadDeleteItemPontuacaoProfissional }
  set loadingDeleteVinculoRelatorios(value: boolean) { this.loadDeleteItemPontuacaoProfissional = value }

  loadCadastroVinculosRelatorios: boolean = false
  get loadingCadastroVinculosRelatorios() { return this.loadCadastroVinculosRelatorios }
  set loadingCadastroVinculosRelatorios(value: boolean) { this.loadCadastroVinculosRelatorios = value }

  itemToDelete: string = ''
  get itemToDeleteId() { return this.itemToDelete }
  set itemToDeleteId(value: string) { this.itemToDelete = value }

  modalDeleteItem: boolean = false
  get showModalDeleteItem() { return this.modalDeleteItem }
  set showModalDeleteItem(value: boolean) { this.modalDeleteItem = value }

  modalCriarItem: boolean = false
  get showModalCriarItem() { return this.modalCriarItem }
  set showModalCriarItem(value: boolean) { this.modalCriarItem = value }

  get relatorioId() { return this.getFinanceiroStore.relatorioId }
  set relatorioId(value: string) { this.getFinanceiroStore.setRelatorioId(value) }

  get pessoaId() { return this.getFinanceiroStore.pessoaId }
  set pessoaId(value: string) { this.getFinanceiroStore.setPessoaId(value) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  formItemVinculoRelatorioRules: any = {
    valid: true,
    pessoaId: [(v: string) => !!v || 'Campo obrigatório'],
    relatorioId: [(v: string) => !!v || 'Campo obrigatório'],
  }

  get itemsTabelaPontuacaoProfissional() {
    return [
      { text: 'Nome', value: 'nome', align: 'left', sortable: false },
      { text: 'Área', value: 'area', align: 'left', sortable: false },
      { text: 'Prestador', value: 'pretador', align: 'center', sortable: false },
      { text: 'Vinculado em', value: 'vinculadoEm', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get vinculosRelatorios() {
    return this.getFinanceiroStore.vinculosRelatorios
  }

  criarItemPontuacaoProfissional() {
    this.getFinanceiroStore.clearItemPontuacaoProfissional()
    this.showModalCriarItem = !this.showModalCriarItem
  }

  setItemToDelete(id: string) {
    this.itemToDeleteId = id
    this.showModalDeleteItem = !this.showModalDeleteItem
  }

  async deleteVinculoRelatorios() {
    this.loadingDeleteVinculoRelatorios = true
    const response = await this.getFinanceiroStore.deleteVinculoRelatorio(this.itemToDeleteId)
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: `Item apagado com sucesso! ${String.fromCodePoint(0x1f642)}`, icon: 'done', color: '#2E7D32' })
      await this.getAllItems()
      this.showModalDeleteItem = false
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um problema com essa requisição. ${String.fromCodePoint(0x1f615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }
    this.loadingDeleteVinculoRelatorios = false
  }

  async getAllItems() {
    this.loadingDataTable = true
    this.getPagina = 1
    await this.getFinanceiroStore.getVinculosRelatorios()
    this.loadingDataTable = false
  }

  async buscarPrestadores(filtro: string = '') {
    const normalizedFilter = filtro.trim()

    this.lastPrestadorSearch = normalizedFilter
    await this.getFinanceiroStore.getPessoaPrestadorAll({
      limite: 10,
      filtro: normalizedFilter,
    })
    
    this.loadingPrestadores = false
    this.loadingPrestadoresGlobal = false
  }

  async createVinculosRelatorios() {
    this.loadingCadastroVinculosRelatorios = true

    if (this.$refs.formItemVinculoRelatorio.validate()) {
      const request = await this.getFinanceiroStore.criarVinculoRelatorio()
      if (request.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Item criado com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.getFinanceiroStore.clearItemVinculoRelatorio()
        this.prestadorSearchModal = ''
        await this.getAllItems()
        this.showModalCriarItem = !this.showModalCriarItem
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }
    this.loadingCadastroVinculosRelatorios = false
  }

  get prestadoresLista() { return this.getFinanceiroStore.prestadoresLista || [] }
  set prestadoresLista(value: any) { this.getFinanceiroStore.setPrestadoresLista(value) }
  get relatoriosAll() { return this.getFinanceiroStore.relatoriosAll || [] }
  get relatoriosAreaEnum() { return this.getFinanceiroStore.relatoriosAreaEnum || [] }

  get relatorioIdFilter() { return this.getFinanceiroStore.relatorioIdFilter }
  set relatorioIdFilter(value: string) { this.getFinanceiroStore.setRelatorioIdFilter(value) }

  get pessoaIdFilter() { return this.getFinanceiroStore.pessoaIdFilter }
  set pessoaIdFilter(value: string) { this.getFinanceiroStore.setPessoaIdFilter(value) }

  get areaFilter() { return this.getFinanceiroStore.areaFilter }
  set areaFilter(value: string) { this.getFinanceiroStore.setAreaFilter(value) }

  async init() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando' })
    this.getFinanceiroStore.clearItemVinculoRelatorio()
    if (this.$refs.formItemVinculoRelatorio) {
      this.$refs.formItemVinculoRelatorio.resetValidation()
    }
    this.prestadorSearchGlobal = ''
    await this.buscarPrestadores()
    await this.getFinanceiroStore.getRelatoriosAll()
    await this.getAllItems()
    await this.getFinanceiroStore.getRelatoriosAreaEnum()
    this.$ga.event('financeiro', 'acessar-tabela-pontuacao-profissional', this.$user.profile.email)
    EventBus.$emit('clearLoadingRequest')
  }

  formatData(date: Date | string) {
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  async mounted() {
    await this.init()
  }

  beforeDestroy() {
    this.debouncedBuscarPrestadores.cancel()
    this.getFinanceiroStore.setRelatorioIdFilter('')
    this.getFinanceiroStore.setPessoaIdFilter('')
    this.getFinanceiroStore.setAreaFilter('')
    this.prestadorSearchGlobal = ''
    this.prestadorSearchModal = ''
  }

  /**
   * Paginação
   */
  get itemsLength() {
    return Math.ceil(this.getFinanceiroStore.totalItemsVinculos / this.getFinanceiroStore.qtdPorPagina)
  }

  get visibleResults() {
    if (this.$vuetify.breakpoint.smAndDown) return 4
    if (this.$vuetify.breakpoint.md) return 7
    if (this.$vuetify.breakpoint.lg) return 9
    return 15
  }

  get getPagina() {
    return this.getFinanceiroStore.paginaVinculosRelatorios
  }


  set getPagina(value: number) {
    this.getFinanceiroStore.setPaginaVinculosRelatorios(value)
  }

  async getResults(pagina: number) {
    this.loadingDataTable = true
    this.getPagina = pagina
    await this.getAllItems()
    this.loadingDataTable = false
  }

  fetchPrestadores() {
    this.loadingPrestadoresGlobal = true
    const filtro = (this.prestadorSearchGlobal || '').trim()

    if (filtro.length < 3) {
      return
    }

    this.debouncedBuscarPrestadores(filtro)
  }

  fetchPrestadoresModal() {
    this.loadingPrestadores = true
    const filtro = (this.prestadorSearchModal || '').trim()

    if (filtro.length < 3) {
      return
    }

    this.debouncedBuscarPrestadores(filtro)
  }

  @Watch('showModalCriarItem')
  onChangeShowModalDeleteItem(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemVinculoRelatorio()
      if (this.$refs.formItemVinculoRelatorio) {
        this.$refs.formItemVinculoRelatorio.resetValidation()
      }
    }
  }

  @Watch('prestadorSearchGlobal')
  onChangePrestadorSearchGlobal(value: string) {
    if (!value || value.trim().length < 3) {
      return
    }

    this.fetchPrestadores()
  }

  @Watch('prestadorSearchModal')
  onChangePrestadorSearchModal(value: string) {
    if (this.suppressPrestadorSearchModal) {
      return
    }

    if (!value || value.trim().length < 3) {
      return
    }

    this.fetchPrestadoresModal()
  }

  onChangePrestadorModal() {
    this.suppressPrestadorSearchModal = true
    this.prestadorSearchModal = ''
    this.$nextTick(() => {
      this.suppressPrestadorSearchModal = false
    })
  }
}
